import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AdditionalInfo from "@/components/common/additionalInfo/additionalInfo";
import OnlineStoreMembershipCard from "@/components/online-store/memberships/onlineStoreMembershipCard";
import OnlineStoreEmptySection from "@/components/online-store/onlineStoreEmptySection";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";
import { MedspaMembership } from "@/views/online-store/onlineStoreView";

type Props = {
  memberships: MedspaMembership[];
};

export default function OnlineStoreMembershipsContainer({
  memberships,
}: Props) {
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  if (memberships.length === 0)
    return (
      <>
        {!isMobile && <SectionHeader />}
        <OnlineStoreEmptySection />
      </>
    );

  return (
    <>
      <AdditionalInfo
        variant="info"
        text="To purchase a membership online, you must already be a client of the medspa."
        sx={{ mb: 5 }}
      />
      <SectionHeader />
      <Grid
        container
        spacing={2}
        sx={{
          mt: 1,
          mb: 10,
        }}
      >
        {memberships?.map((membership) => (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={membership.id}>
            <OnlineStoreMembershipCard membership={membership} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

const SectionHeader = () => {
  return (
    <Stack
      spacing={1}
      sx={{
        mt: 3,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: "text.primary",
        }}
      >
        All memberships
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
        }}
      >
        Take advantage of our full range of memberships.
      </Typography>
    </Stack>
  );
};
